module.exports = __webpack_public_path__ + "img/step-1.043169eb.gif";